export const styleSample = `
  .sb-story,.sb-show-main { border: solid 1px #333; height: 500px; width: 800px; padding:40px; position: relative;}
  .pn-chat { position:absolute; right:50px ;bottom:50px; transform-origin: bottom right }
  }`;

export const hardcodedMessages = 
{
  "header": {
    "body": null,
    "button": null
  },
  "messages": [
    {
      "category": "System",
      "content": "A customer service agent has entered the chat.",
      "messageId": "14584740-7784-4749-9b39-bce31455ea55"
    },
    {
      "category": "Bot",
      "content": "Varmt välkommen till PostNords virtuella assistent. Jag kan hjälpa dig med frågor gällande brev och paket samt skicka dig vidare till vår kundservice.",
      "messageId": "967ddba6-ba1c-44d1-9725-386b32dc3498"
    },
    {
      "category": "Bot",
      "content": "Hur kan jag hjälpa dig?",
      "messageId": "b26624af-852b-49cf-a3e6-77cc046be71f"
    },
    {
      "class": null,
      "category": "User",
      "content": "hejsan vart är mitt paket?",
      "messageId": "74cadc59-86ad-4f11-b4b6-a263aa9dbad9"
    },
    {
      "category": "Bot",
      "content": "Om du har ett kollinummer som berör din fråga, skriv gärna det här.",
      "messageId": "90845d71-2a8e-4b1a-bd45-20de7a2dbe5f"
    },
    {
      "category": "Link",
      "content": "Postnord.se",
      "href": "https://www.postnord.se/",
      "messageId": "90845d71-2a8e-4b1a-bd45-20de7a2dbe5t"
    },
    {
      "category": "Button",
      "content": "Click me",
      "messageId": "90845d71-2a8e-4b1a-bd45-20de7a2dbe5l",
      "props": "{\"appearance\": \"light\", \"variant\": \"outlined\", \"data-option-choice\": \"\", \"data-action\": \"choice\"}"
    },
    {
      "category": "Button",
      "content": "Click me 2",
      "messageId": "90845d71-2a8e-4b1a-bd45-20de7a2dbe5l3",
      "props": "{\"appearance\": \"light\", \"variant\": \"outlined\", \"data-option-choice\": \"\", \"data-action\": \"choice\"}"
    }
  ]
};

export const messageObjectReal = {
  header: {
    body: null,
    button: null
  },
  messages: [
    {
      class: null,
      category: "User",
      content: "test",
      messageId: "4a703929-4f6c-47df-bfc1-5a4ca6e31531"
    },
    {
      class: null,
      category: "User",
      content: "test",
      messageId: "00000000-0000-0000-0000-000000000000"
    },
    {
      class: null,
      category: "User",
      content: "m",
      messageId: "55d2851f-66d5-47d8-a4f7-1114a22d3d16"
    },
    {
      class: "",
      props: "1ef8d9da-316b-45de-b56a-ec595b8baef3",
      category: "Button",
      content: "End Chat",
      messageId: "4cd676a7-5e8f-4781-b263-45a5ab1bc0e1"
    },
    {
      class: "",
      props: "9290fec2-bf1f-4713-9060-5f88ff8a7420",
      category: "Button",
      content: "Chat with Agent",
      messageId: "4cd676a7-5e8f-4781-b263-45a5ab1bc0e1"
    },
    {
      category: "Bot",
      content: "Welcome! I am the PN bot. How can I help you today?\nPlease select an option below :",
      messageId: "4cd676a7-5e8f-4781-b263-45a5ab1bc0e1"
    },
    {
      class: "",
      props: "fb0b3b50-97a0-40f7-872a-fc6d7ed0d379",
      category: "Button",
      content: "End Chat",
      messageId: "2ecd1b25-8790-40a4-a596-efe0881f7519"
    },
    {
      class: "",
      props: "598e284a-4480-4e09-8f69-6c7046fea704",
      category: "Button",
      content: "Chat with Agent",
      messageId: "2ecd1b25-8790-40a4-a596-efe0881f7519"
    },
    {
      category: "Bot",
      content: "Welcome! I am the PN bot. How can I help you today?\nPlease select an option below :",
      messageId: "2ecd1b25-8790-40a4-a596-efe0881f7519"
    }
  ]
};

